import { setPaymentMethods, setErrorMessage } from "./action";
import { PAYMENT_TYPES } from "./constant";

export const is = (paymentMethod, paymentType) => {
  return paymentMethod === PAYMENT_TYPES[paymentType];
};

export const getPaymentOptions =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const {
        data: {
          sell: { items: sellOptions },
        },
      } = await remote(
        "get",
        `v3/customers/payment-options`,
        {},
        "get payments options for customers",
        dispatch
      );

      dispatch(
        setPaymentMethods(
          sellOptions
            .map((m) => ({
              paymentMethod: m.paymentMethod || m.sourceType,
              ...m,
            }))
            .filter((m) => m.paymentMethod !== PAYMENT_TYPES.PAYPALEXPRESS)
        )
      );
    } catch (error) {
      dispatch(setPaymentMethods([]));
      dispatch(setErrorMessage(error.message[0]));
    }
  };

export const setDefaultPaymentOption =
  (id) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const setDefaultPaymentOption = await remote(
        "put",
        `v3/customers/payment-options/${id}`,
        { default: true },
        "modifying default payment option",
        dispatch
      );

      if (setDefaultPaymentOption.message) {
        throw setDefaultPaymentOption;
      }

      dispatch(getPaymentOptions());
    } catch (error) {
      dispatch(setErrorMessage(error.message[0]));
    }
  };

export const addDefaultPaymentOption =
  (body, closeModal) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const addDefaultPaymentOption = await remote(
        "post",
        `v3/customers/payment-options`,
        body,
        "creating default payment option",
        dispatch
      );

      if (addDefaultPaymentOption.message) {
        throw addDefaultPaymentOption;
      }

      dispatch(getPaymentOptions());
      if (closeModal) {
        closeModal();
      }
    } catch (error) {
      dispatch(setErrorMessage(error.message[0]));
    }
  };
